import './assets';

import { setupBroadbandCheck } from './components/broadband-check';
import { setupConnectivityChecker } from './components/connectivity-checker';
import { setupColtSearch } from './components/search';
import { connectAddressField } from './components/connect-address-field';

window.dataLayer = window?.dataLayer || [];

window.addEventListener(
	'DOMContentLoaded',
	function () {
		setupBroadbandCheck();
		setupConnectivityChecker();
		setupColtSearch();
		connectAddressField();
	}
);
